// extracted by mini-css-extract-plugin
module.exports = {"addCandidate":"styles_addCandidate__1Z_8e","addCandidateForm":"styles_addCandidateForm__3wPqW","errorResponse":"styles_errorResponse__1ql7g"};